export function isProbablyUrl(value: string): boolean {
  return /^https?:\/\//i.test(value.trim());
}

export function isProbablyUuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value.trim());
}

function normalizeBaseUrl(baseUrl: string): string {
  const trimmed = (baseUrl ?? '').trim();
  if (!trimmed) return '';
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
}

export function buildMediaUrlFromAssetId(assetId: string): string {
  const apiBase = (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.VITE_API_URL ?? '';
  const base = normalizeBaseUrl(apiBase);
  return `${base}/api/v1/media/${assetId}`;
}

export function resolveMediaRefToUrl(ref?: string | null): string | null {
  if (!ref) return null;
  const value = ref.trim();
  if (!value) return null;
  if (isProbablyUrl(value)) return value;
  if (isProbablyUuid(value)) return buildMediaUrlFromAssetId(value);
  return null;
}




